Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var InfiniteScroll = require('react-infinite-scroll-component');
var ChatComment = require('@ds-developer/chat-comment');
var core = require('@material-ui/core');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var InfiniteScroll__default = /*#__PURE__*/_interopDefaultLegacy(InfiniteScroll);
var ChatComment__default = /*#__PURE__*/_interopDefaultLegacy(ChatComment);
var useStyles = core.makeStyles(function (theme) {
  return {
    list: {
      display: "flex",
      flexDirection: "column-reverse",
      padding: theme.spacing(0, 3, 0, 0)
    },
    scrollContainer: function scrollContainer(_a) {
      var height = _a.height,
        width = _a.width;
      return {
        display: "flex",
        flexDirection: "column-reverse",
        height: height,
        overflow: "auto",
        width: width
      };
    },
    loading: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      padding: theme.spacing(2),
      position: "relative"
    }
  };
});
var ChatList = function ChatList(_a) {
  var height = _a.height,
    loadMore = _a.loadMore,
    messages = _a.messages,
    _b = _a.moreMessagesAvailable,
    moreMessagesAvailable = _b === void 0 ? true : _b,
    width = _a.width;
  var classes = useStyles({
    height: height,
    width: width
  });
  var chatComments = messages.map(function (_a, index) {
    var sender = _a.sender,
      message = _a.message;
    return React__default['default'].createElement(ChatComment__default['default'], {
      "data-test": "chat-comment",
      key: "" + message.body + index,
      sender: sender,
      message: message
    });
  });
  return React__default['default'].createElement("div", {
    id: "chatListScrollContainer",
    "data-test": "chat-list",
    className: classes.scrollContainer
  }, React__default['default'].createElement(InfiniteScroll__default['default'], {
    className: classes.list,
    dataLength: messages.length,
    hasMore: moreMessagesAvailable,
    height: height,
    initialScrollY: height,
    inverse: true,
    loader: React__default['default'].createElement("span", {
      className: classes.loading,
      key: "loading-messages"
    }, React__default['default'].createElement(core.CircularProgress, null)),
    next: function next() {
      return loadMore();
    },
    scrollableTarget: "chatListScrollContainer"
  }, chatComments));
};
exports.default = ChatList;